import {
  AtomListRowItem,
  IconDrilldownForward,
  ListRowItem,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames';
import { FC, memo } from 'react';
import styles from './ApplicationDetailRow.module.scss';

const cx = classnames.bind(styles);

export type ApplicationDetailRowProps = {
  title: string;
  beforeValue?: string;
  afterValue: string;
  testIdSuffix: string;
  checked?: boolean;
  onChange: (checked: boolean) => void;
  tooltip?: string;
};

const InnerApplicationDetailRow: FC<ApplicationDetailRowProps> = memo(
  ({
    title,
    beforeValue,
    afterValue,
    testIdSuffix,
    checked,
    onChange,
    tooltip,
  }) => {
    return (
      <div className={cx(styles['list-row-row'])}>
        <AtomListRowItem
          containerClassName={cx(styles['list-row-th'])}
          testId={`body-title-${testIdSuffix}`}
          title={title}
          type='bodyTitle'
        />
        <AtomListRowItem
          containerClassName={cx(styles['list-row-before'])}
          testId={`body-text-${testIdSuffix}`}
          title={beforeValue}
          type='body'
        />
        <div className={cx(styles['list-row-icon-cell'])}>
          <IconDrilldownForward size={18} />
        </div>
        <ListRowItem
          containerClassName={cx(styles['list-row-after'])}
          inputId={`body-checkbox-${testIdSuffix}`}
          testId={`body-checkbox-${testIdSuffix}`}
          label={afterValue}
          type='body'
          checked={checked}
          onChange={() => onChange(!checked)}
          tooltip={tooltip}
          tooltipIcon='info'
        />
      </div>
    );
  }
);

InnerApplicationDetailRow.displayName = 'InnerApplicationDetailRow';

export const ApplicationDetailRow = InnerApplicationDetailRow;
